import { Dialog, Divider, Slide } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useRef } from "react";
import { forwardRef, useState } from "react";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalComp({
  button,
  children,
  title,
  divider,
  login,
  afterOpenMethod,
}) {
  const [open, setOpen] = useState(false);
  const [headerTop, setHeaderTop] = useState(false);
  const scroll = useRef();
  const header = useRef();
  const modalToggle = () => {
    if (login === "") return;
    setOpen(!open);
  };
  const scrollHandler = (e) => {
    if (e.target.scrollTop <= 0) {
      setHeaderTop(false);
    } else {
      setHeaderTop(true);
    }
  };
  useEffect(() => {
    if (!open) return;
    afterOpenMethod && afterOpenMethod();
    setTimeout(() => {
      if (scroll.current) {
        let target = scroll.current;
        target.addEventListener("scroll", scrollHandler, false);
        return () => {
          target.removeEventListener("scroll", scrollHandler, false);
        };
      }
    });
  }, [open]);

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={modalToggle}
        TransitionComponent={Transition}
      >
        <Box
          sx={{ display: "flex", flexDirection: "column", overflow: "auto", paddingTop: "7rem" }}
          ref={scroll}
        >
          <Box
            sx={{
              textAlign: "left",
              padding: "15px 10px",
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              position: "fixed",
              top: "0",
              backgroundColor: "#fff",
              zIndex: 2,
              width: '100%'
            }}
            ref={header}
          >
            <img style={{position:"absolute"}} src="/img/back_button_black.png" onClick={modalToggle} />
            <Box
              sx={
                !headerTop
                  ? {
                      margin: "50px 0 0 10px",
                      fontSize: "22px",
                      position: "relative",
                      left: "0",
                      transition: "all 0.2s",
                    }
                  : {
                      margin: "0",
                      position: "relative",
                      left: "50%",
                      transform: "translate(-50%, 0)",
                      transition: "all 0.2s",
                    }
              }
            >
              {title}
            </Box>

            {divider && (
              <Divider
                className="w-full"
                style={{
                  position: "absolute",
                  bottom: "0",
                  left: "0",
                }}
              />
            )}
          </Box>

          <Box>{children}</Box>
        </Box>
      </Dialog>

      <div onClick={modalToggle}>{button}</div>
    </>
  );
}
